import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const DiagnosisService = {
  getDiagnosisList(params: any){ return axiosRequest('GET', API_PATH.DIAGNOSIS.LIST(params)) },
  getDiagnosis(data: any){ return axiosRequest('POST', API_PATH.DIAGNOSIS.INFO, data) },
  addDiagnosis(data: any){ return axiosRequest('POST', API_PATH.DIAGNOSIS.ADD, data) },
  deleteDiagnosis(data: any){ return axiosRequest('POST', API_PATH.DIAGNOSIS.DELETE, data) },
}